import { useMutation } from '@tanstack/react-query'
import { deleteHistoryByFilter } from '../api/plan-override-history-api'
import type { DeleteHistoryByFilterResponseDto } from '../api/dto/common.dto'

export function useDeleteHistoryByFilter(ruleBase: string) {
  return useMutation<
    DeleteHistoryByFilterResponseDto,
    unknown,
    Record<string, unknown> | undefined
  >({
    mutationFn: (params) => deleteHistoryByFilter(ruleBase, params),
  })
}
